import { GlobalStyle, Container } from "../../common/styles/global-style"
import { useEffect, useState } from "react"
import { ListView, FabButton, CustomModal,Wrapper} from "../../common"
import { FaPlus } from "react-icons/fa"
import { ActionsItem } from "./actions-item"
import { FormCreateAction } from "./from-create-actions/form-create-action"
import { Action } from "./application/domain/actions"
import { useParams } from "react-router-dom"
import { Load } from "../../common/load/load"
import { ActionController } from "./infra/controller/action.controller"
import { ActionsHeader } from "./application/actions-header"

import { ActionsTopMenu } from "./actions-top-menu"

export const ActionsUi = () => {
    const [actions, setActions] = useState<Action[]>([])
    const [workout, setWorkout] = useState<string>("")
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [load, setLoad] = useState(false)
    const { workoutId } = useParams<{ workoutId: string }>()

    useEffect(() => {
        const fetchActions = async () => {
            await ActionController.list({
                workoutId: workoutId ?? "",
                setActions,
                setWorkout,
                setLoad
            });
        };
        fetchActions();
    }, []);

    const submitCreateAction = async (color: string, description: string): Promise<void> => {
        await ActionController.create({
            workoutId: workoutId ?? "",
            color,
            description,
            setLoad,
            setActions,
            setIsModalOpen
        });
    }

    return (
        <>
            <GlobalStyle />
            {load && <Load />}
            <ActionsTopMenu actions={actions} workoutId={workoutId ?? ""} />            
            <Container>
                <Wrapper>
                    <ActionsHeader workout={workout} actions={actions} isLoading={load} />            
                    <ListView
                        top="20px">
                        {actions.map((action) => (
                            <ActionsItem
                                key={action.id}
                                description={action.description ?? ""}
                                color={action.color}
                            />
                        ))}
                    </ListView>
                    <FabButton
                        icon={<FaPlus />}
                        position="bottom-right"
                        size={56}
                        onClick={() => setIsModalOpen(true)}
                    />
                    <CustomModal
                        isOpen={isModalOpen}
                        onRequestClose={() => setIsModalOpen(false)}
                        contentLabel="Adicionar Estímulo"
                    >
                        <FormCreateAction
                            onSubmit={submitCreateAction}
                            loading={load}                            
                        />
                    </CustomModal>
                </Wrapper>
            </Container>
        </>
    )
}